import { render, staticRenderFns } from "./BookVersionCard.vue?vue&type=template&id=b81a01b8&scoped=true&"
import script from "./BookVersionCard.vue?vue&type=script&lang=js&"
export * from "./BookVersionCard.vue?vue&type=script&lang=js&"
import style0 from "./BookVersionCard.vue?vue&type=style&index=0&id=b81a01b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81a01b8",
  null
  
)

export default component.exports